/**
 * URL 로 유지되는 미러 필터 상태 훅 (service/category/period/month/start/end/storeId).
 *
 * 왜 URL 인가: 새로고침·공유·뒤로가기에도 스코프가 유지된다(회원 관리 딥링크와 같은 패턴,
 *   owner-console-v2/core/Members.jsx). 상태를 컴포넌트 지역 useState 로 들면 새로고침에 날아간다.
 *
 * 규칙:
 *   - 잘못된 값은 무시하고 안전 기본값으로 정규화(period 화이트리스트, YYYY-MM / YYYY-MM-DD 형식 검증).
 *   - 기본값과 같아지면 파라미터를 지워 URL 을 깔끔하게 유지(service=기본, 빈 값).
 *   - update(patch) 는 부분 갱신 — 넘긴 키만 바꾸고 { replace:true } 로 히스토리를 오염시키지 않는다.
 */
import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PERIOD_KEYS, DEFAULT_PERIOD } from './mirrorFormat';

const YM_RE = /^\d{4}-\d{2}$/;
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
const SERVICES = ['mogoo', 'modernwash'];

export default function useMirrorFilters({ defaultService = 'mogoo' } = {}) {
  const [sp, setSp] = useSearchParams();

  const rawService = sp.get('service');
  const service = SERVICES.includes(rawService) ? rawService : defaultService;
  const period = PERIOD_KEYS.includes(sp.get('period')) ? sp.get('period') : DEFAULT_PERIOD;
  const month = YM_RE.test(sp.get('month') || '') ? sp.get('month') : '';
  const start = DATE_RE.test(sp.get('start') || '') ? sp.get('start') : '';
  const end = DATE_RE.test(sp.get('end') || '') ? sp.get('end') : '';

  const value = {
    service,
    category: sp.get('category') || '',
    period,
    month,
    start,
    end,
    storeId: sp.get('storeId') || '',
  };

  const update = useCallback(
    (patch) => {
      setSp(
        (prev) => {
          const next = new URLSearchParams(prev);
          Object.entries(patch).forEach(([k, v]) => {
            if (v === undefined || v === null || v === '') next.delete(k);
            else next.set(k, v);
          });
          // service 를 기본값으로 되돌리면 파라미터 자체를 지운다(공유 URL 을 짧게).
          if (patch.service === defaultService) next.delete('service');
          return next;
        },
        { replace: true },
      );
    },
    [setSp, defaultService],
  );

  return [value, update];
}
